module.exports = __webpack_public_path__ + "static/media/davantiBg.fe02aaf0.png";